import React, { useContext, useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { ActivitiesContext } from "../../context/ActivitiesContext";
import ActivityCard from "../../_components/common/ActivityCard";

// Helper to calculate distance between two coordinates (Haversine formula)
const haversineDistance = (lat1, lng1, lat2, lng2) => {
  const R = 6371; // Radius of Earth in km
  const toRad = (deg) => (deg * Math.PI) / 180;

  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);

  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) *
      Math.cos(toRad(lat2)) *
      Math.sin(dLng / 2) ** 2;

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c; // Distance in km
};

const ScenarioSimulator = ({ show, onHide, dayNumber, onPlanChanged }) => {
  const [location, setLocation] = useState("");
  const [time, setTime] = useState("");
  const [result, setResult] = useState(null);
  const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  const { activities,planId } = useContext(ActivitiesContext);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showChangePlanPopup, setShowChangePlanPopup] = useState(false);
  const [showSuccessChangePopup, setshowSuccessChangePopup] = useState(false);
  const [matchedActivity, setMatchedActivity] = useState(null);
const [distanceKm, setDistanceKm] = useState(null);
const [currentDayIndex, setCurrentDayIndex] = useState(null);


// const [activityToChange, setActivityToChange] = useState(null);

  const toMinutes = (timeStr) => {
    const [time, modifier] = timeStr.split(" ");
    if (modifier) {
      let [hours, minutes] = time.split(":").map(Number);
      if (modifier === "PM" && hours !== 12) hours += 12;
      if (modifier === "AM" && hours === 12) hours = 0;
      return hours * 60 + minutes;
    } else {
      const [hours, minutes] = timeStr.split(":").map(Number);
      return hours * 60 + minutes;
    }
  };

  const handleSimulate = async (e) => {
    e.preventDefault();

    const currentDayIndex = parseInt(dayNumber) - 1;
    setCurrentDayIndex(currentDayIndex);
    const dayData = activities[currentDayIndex];
    const plan = dayData?.plan || [];
    // const [activityToChange, setActivityToChange] = useState(null);

    const geoRes = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(location)}&key=${GOOGLE_MAPS_API_KEY}`
    );
    
    const geoData = await geoRes.json();
    
    if (geoData.status !== "OK" || geoData.results.length === 0) {
      setResult("Could not determine location coordinates.");
      return;
    }
    
    const userLat = geoData.results[0].geometry.location.lat;
    const userLng = geoData.results[0].geometry.location.lng;
    // console.log("lat",userLat);
    // console.log("lng",userLng);
    

    const userMinutes = toMinutes(time);

    const activity = plan.find(({ start_time, end_time }) => {
      const startMins = toMinutes(start_time);
      const endMins = toMinutes(end_time);
      return userMinutes >= startMins && userMinutes <= endMins;
    });
    if (!activity || !activity.place_id) {
      setResult(`No matching activity found at ${time}.`);
      return;
    }
    const actRes = await fetch(`https://citygetaway-backend-plan-service.vercel.app/api/place_lat_lng?place_id=${activity.place_id}`, {
      headers: {
        "X-User-Name": "testDan",
        "X-User-Id": "681a6db71771cb427864f564",
      }
    });
  
    const actData = await actRes.json();
    const lat=actData.lat
    const lng=actData.lng
    const distanceKm = haversineDistance(userLat, userLng, lat, lng);
    setMatchedActivity(activity);
    setDistanceKm(distanceKm);

  if (distanceKm <= 1) {
    setShowSuccessPopup(true);
    // setResult(`At ${time}, you're near "${activity.location}" (within ${distanceKm.toFixed(2)} km)`);
  } else {
    setShowChangePlanPopup(true);
    // setResult(`You're too far from "${activity.location}" (about ${distanceKm.toFixed(2)} km away)`);
  }
  

    // setResult(message);
    console.log(activity)

    // console.log("pan",planId)
  };
  const handleChangePlan = async () => {
    const requestBody = {
      "budget": 500,
      "day_index": currentDayIndex,
      "end_time": matchedActivity.end_time,
      "hotel_location": [
          45.4959,
          -73.6206
      ],
      "location": [
          45.4959,
          -73.6206
      ],
      "max_travel_time": 45,
      "plan_id": planId,
      "place_id": matchedActivity.place_id,
      "preferences": [
          "Shopping",
          "Sightseeing"
      ],
      "radius": 2500,
      "replace_activities": [
        matchedActivity.name,
      ],
      "start_time": matchedActivity.start_time,
      "multi_day_itinerary": activities,
  }
  
    const newActivity = await fetchActivities(requestBody);
    console.log("New activity:", newActivity.new_activity_name);
  
    if (newActivity) {
      setMatchedActivity(newActivity.new_activity_name);
      setShowChangePlanPopup(false);
      setshowSuccessChangePopup(true); // Optionally show success message
      console.log("Response from scenario simulator:", newActivity);

      if (onPlanChanged) {
        onPlanChanged(newActivity); // pass new activity or updated plan data
      }
    } else {
      alert("Failed to fetch new activity.");
    }
  };
  
  const fetchActivities = async (requestBody) => {
    try {
      const response = await fetch("https://citygetaway-backend-plan-service.vercel.app/api/change_activity", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-User-Name": "testDan",
          "X-User-Id": "681a6db71771cb427864f564", // TODO: dynamic later
        },
        body: JSON.stringify(requestBody),
      });
  
      return response.ok ? await response.json() : false;
    } catch (error) {
      console.error("Error fetching activities:", error.message || "Unknown error");
      return false;
    }
  };
  


  const handleModalClose = () => {
    // Clear inputs and results
    setLocation("");
    setTime("");
    setResult(null);
    onHide();
  };
  return (
    <>
      {/* Main Simulator Modal */}
      <Modal show={show} onHide={handleModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Scenario Simulator - Day {dayNumber}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSimulate}>
            <Form.Group className="mb-3" controlId="formLocation">
              <Form.Label>Location</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter location"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                required
              />
            </Form.Group>
  
            <Form.Group className="mb-3" controlId="formTime">
              <Form.Label>Time</Form.Label>
              <Form.Control
                type="time"
                value={time}
                onChange={(e) => setTime(e.target.value)}
                required
              />
            </Form.Group>
  
            <Button variant="primary" type="submit" className="w-100">
              Run Simulation
            </Button>
          </Form>
  
          {result && <div className="mt-3 alert alert-info">{result}</div>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
  
      {/* Success Popup */}
      <Modal show={showSuccessPopup} onHide={() => setShowSuccessPopup(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>You're on the right track!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        {`At ${time}, you're near "${matchedActivity?.location || matchedActivity?.name}" (within 1 km).`}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={() => setShowSuccessPopup(false)}>Great!</Button>
        </Modal.Footer>
      </Modal>
  
      {/* Change Plan Popup */}
      <Modal show={showChangePlanPopup} onHide={() => setShowChangePlanPopup(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Too Far</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          You're about {distanceKm?.toFixed(2)} km away from "{matchedActivity?.location}".<br />
          Do you want to change your plan?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowChangePlanPopup(false)}>Keep Plan</Button>
          <Button variant="danger" onClick={handleChangePlan}

          >Change Plan</Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showSuccessChangePopup} onHide={() => setshowSuccessChangePopup(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>You're on the right track!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        {matchedActivity
      ? `Your plan has been updated. New activity: "${matchedActivity}".`
      : `At ${time}, you're near "${matchedActivity?.location || matchedActivity?.name}" (within 1 km).`}
          {/* At {time}, you're near "{matchedActivity?.location}" (within 1 km). */}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={() => setShowSuccessPopup(false)}>Great!</Button>
        </Modal.Footer>
      </Modal>
      

    </>
  );
};
  export default ScenarioSimulator;